export const stack: {
  name: string;
  description: string;
  href: string;
  featured?: boolean;
  affiliate?: boolean;
}[] = [
  // Development & Code Editors
  {
    name: 'Cursor',
    description: 'Primary code editor for all development work.',
    href: 'https://www.cursor.com/',
    featured: true,
  },
  {
    name: 'Git',
    description: 'Version control and collaboration.',
    href: 'https://git-scm.com/',
  },
  {
    name: 'GitHub',
    description: 'Code hosting and project collaboration.',
    href: 'https://github.com/',
    featured: true,
  },

  // Frontend Technologies
  {
    name: 'React',
    description: 'Library for building user interfaces.',
    href: 'https://react.dev/',
    featured: true,
  },
  {
    name: 'Next.js',
    description: 'Full-stack React framework.',
    href: 'https://nextjs.org/',
    featured: true,
  },
  {
    name: 'Remix',
    description: 'Web framework focused on web standards.',
    href: 'https://remix.run/',
  },
  {
    name: 'TailwindCSS',
    description: 'Utility-first CSS framework.',
    href: 'https://tailwindcss.com/',
    featured: true,
  },
  {
    name: 'TypeScript',
    description: 'JavaScript with static type checking.',
    href: 'https://www.typescriptlang.org/',
    featured: true,
  },
  {
    name: 'Svelte',
    description: 'Cybernetically enhanced web apps.',
    href: 'https://svelte.dev/',
  },

  // Backend & Database
  {
    name: 'Node.js',
    description: 'JavaScript runtime for server-side development.',
    href: 'https://nodejs.org/',
    featured: true,
  },
  {
    name: 'Express',
    description: 'Fast, unopinionated web framework for Node.js.',
    href: 'https://expressjs.com/',
  },
  {
    name: 'Drizzle',
    description: 'Database toolkit for TypeScript.',
    href: 'https://orm.drizzle.team/',
    featured: true,
  },
  {
    name: 'Prisma',
    description: 'Next-generation database toolkit.',
    href: 'https://www.prisma.io/',
  },
  {
    name: 'PostgreSQL',
    description: 'Relational database management system.',
    href: 'https://www.postgresql.org/',
    featured: true,
  },
  {
    name: 'Redis',
    description: 'In-memory data structure store.',
    href: 'https://redis.io/',
  },
  {
    name: 'MongoDB',
    description: 'Document-based NoSQL database.',
    href: 'https://www.mongodb.com/',
  },

  // Cloud & Infrastructure
  {
    name: 'AWS',
    description: 'Cloud computing services and infrastructure.',
    href: 'https://aws.amazon.com/',
    featured: true,
  },
  {
    name: 'Railway',
    description: 'Cloud platform for deploying applications.',
    href: 'https://railway.app/',
  },
  {
    name: 'Vercel',
    description: 'Platform for deploying frontend applications.',
    href: 'https://vercel.com/',
    featured: true,
  },

  // Development Tools
  {
    name: 'Vite',
    description: 'Next generation frontend build tool.',
    href: 'https://vitejs.dev/',
  },
  {
    name: 'Storybook',
    description: 'Tool for building UI components in isolation.',
    href: 'https://storybook.js.org/',
  },
  {
    name: 'Playwright',
    description: 'End-to-end testing framework.',
    href: 'https://playwright.dev/',
  },
  {
    name: 'Vitest',
    description: 'Fast unit testing framework.',
    href: 'https://vitest.dev/',
  },

  // Design & UX
  {
    name: 'Figma',
    description: 'Collaborative interface design tool.',
    href: 'https://www.figma.com/',
    featured: true,
  },

  // Content Management
  {
    name: 'Sanity',
    description: 'Headless CMS for structured content.',
    href: 'https://www.sanity.io/',
  },
  {
    name: 'Payload CMS',
    description: 'Code-first headless CMS.',
    href: 'https://payloadcms.com/',
    featured: true,
  },

  // Performance & Optimization
  {
    name: 'Sharp',
    description: 'High-performance image processing.',
    href: 'https://sharp.pixelplumbing.com/',
  },
  {
    name: 'WebGL',
    description: 'Web-based graphics library for 3D graphics.',
    href: 'https://www.khronos.org/webgl/',
  },

  // Background Jobs & Queues
  {
    name: 'BullMQ',
    description: 'Queue package for Node.js.',
    href: 'https://docs.bullmq.io/',
  },

  // Real-time Communication
  {
    name: 'WebSockets',
    description: 'Real-time bidirectional communication.',
    href: 'https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API',
  },

  // Infrastructure as Code
  {
    name: 'SST',
    description: 'Framework for building serverless applications.',
    href: 'https://sst.dev/',
  },

  // Professional Communication
  {
    name: 'Github Projects',
    description: 'Project and issue tracking.',
    href: 'https://github.com/features/project-management',
    featured: true,
  },
  {
    name: 'WhatsApp',
    description: 'Everyday private communication.',
    href: 'https://www.whatsapp.com/',
    featured: true,
  },
  {
    name: 'Slack',
    description: 'Team communication and collaboration.',
    href: 'https://slack.com/',
  },
  {
    name: 'Notion',
    description: 'All-in-one workspace for notes and documentation.',
    href: 'https://www.notion.so/',
  },
];

